import { BaseApiManager, ApiResponse } from './BaseApiManager';

export class AuthApiManager extends BaseApiManager {
  private static instance: AuthApiManager;

  private constructor() {
    super();
  }

  public static getInstance(): AuthApiManager {
    if (!AuthApiManager.instance) {
      AuthApiManager.instance = new AuthApiManager();
    }
    return AuthApiManager.instance;
  }

  public async login(credentials: { username: string; password: string }): Promise<ApiResponse<any>> {
    return this.request('/core/auth/login', {
      method: 'POST',
      body: JSON.stringify(credentials),
      skipAuth: true,
    });
  }

  public async register(userData: { username: string; email: string; password: string }): Promise<ApiResponse<any>> {
    return this.request('/core/users/register', {
      method: 'POST',
      body: JSON.stringify({ users: [userData] }),
      skipAuth: true,
    });
  }

  public async recoverPassword(email: string): Promise<ApiResponse<any>> {
    return this.request('/core/auth/recover-password', {
      method: 'POST',
      body: JSON.stringify({ email }),
      skipAuth: true,
    });
  }

  public async checkUserProfile(userId: string | number): Promise<ApiResponse<any>> {
    return this.request(`/core/users/full-info-user/${userId}`);
  }

  public async registerProfile(userId: string | number, profileData: any): Promise<ApiResponse<any>> {
    return this.request(`/core/users/register-profile/${userId}`, {
      method: 'POST',
      body: JSON.stringify(profileData),
    });
  }

  public async createUserFromClerk(userData: {
    clerkId: string;
    email: string;
    username: string;
    firstName?: string;
    lastName?: string;
  }): Promise<ApiResponse<any>> {
    return this.request('/core/auth/create-clerk-user', {
      method: 'POST',
      body: JSON.stringify(userData),
      skipAuth: true,
    });
  }

  public async checkClerkUser(clerkId: string): Promise<ApiResponse<any>> {
    return this.request(`/core/auth/check-clerk-user/${clerkId}`, {
      method: 'GET',
      skipAuth: true,
    });
  }

  public async saveUserGoals(userId: string | number, goalsData: any): Promise<ApiResponse<any>> {
    return this.request(`/core/users/${userId}/goals`, {
      method: 'POST',
      body: JSON.stringify(goalsData),
    });
  }

  public async getUserProfile(userId: string | number): Promise<ApiResponse<any>> {
    return this.request(`/core/users/${userId}/profile`);
  }
}
